import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";
function App() {
    const {i18n} = useTranslation();
    return (
        <div dir={i18n.language === "ar" ? "rtl" : "ltr"}>
            <Outlet/>
        </div>
    );
}
export default App;
